/* OneCircle Suche - Storefront.
   Legt sich additiv ueber die bestehende Suche. Faellt irgendetwas aus,
   bleibt die native Shopify-Ausgabe unveraendert stehen (Fallback-Prinzip).
   Alle sichtbaren Texte kommen vom Server und sind im Admin pflegbar. */

(function () {
  'use strict';

  var wurzel = document.getElementById('oc-suche-konfig');
  if (!wurzel) return;

  var konfig;
  try {
    konfig = JSON.parse(wurzel.textContent || '{}');
  } catch (fehler) {
    return;
  }

  var BASIS = (konfig.proxy || '/apps/suche').replace(/\/+$/, '');
  var TEXTE = {
    ergebnisse_titel: 'Suchergebnisse',
    ergebnisse_fuer: 'Ergebnisse f\u00fcr',
    treffer_mehrzahl: 'Treffer',
    keine_treffer_titel: 'Keine Treffer',
    keine_treffer_text: 'Zu dieser Suche haben wir nichts gefunden.',
    meintest_du: 'Meintest du',
    verkauft_von: 'Verkauft von',
    uvp_label: 'UVP',
    nicht_vorraetig: 'Nicht vorr\u00e4tig',
    filter_titel: 'Filter',
    filter_weitere: 'Weitere Filter',
    filter_zuruecksetzen: 'Alle Filter zur\u00fccksetzen',
    filter_anzeigen: 'Ergebnisse anzeigen',
    filter_schliessen: 'Filter schliessen',
    sortierung_label: 'Sortieren nach',
    sortierung_relevanz: 'Relevanz',
    sortierung_preis_auf: 'Preis aufsteigend',
    sortierung_preis_ab: 'Preis absteigend',
    sortierung_neu: 'Neuheiten',
    sortierung_bestseller: 'Beliebt',
    mehr_laden: 'Mehr anzeigen',
    laedt: 'Wird geladen',
    angebot: 'Im Angebot',
    preis_von: 'von',
    preis_bis: 'bis',
    vorschlag_kategorien: 'Kategorien',
    vorschlag_haendler: 'H\u00e4ndler',
    vorschlag_produkte: 'Produkte',
    alle_ergebnisse: 'Alle Ergebnisse anzeigen',
    empfehlungen_titel: 'Das k\u00f6nnte auch passen',
    beliebt_titel: 'H\u00e4ufig gesucht'
  };

  // -------------------------------------------------------------------------
  // Hilfen
  // -------------------------------------------------------------------------
  function sicher(text) {
    return String(text === undefined || text === null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function preisText(wert, waehrung) {
    if (wert === null || wert === undefined) return '';
    return Number(wert).toFixed(2).replace('.', ',') + ' ' + (waehrung || 'EUR');
  }

  function elementAus(html) {
    var huelle = document.createElement('div');
    huelle.innerHTML = html;
    return huelle.firstElementChild;
  }

  function ersterTreffer(auswahlListe) {
    for (var i = 0; i < auswahlListe.length; i++) {
      var auswahl = auswahlListe[i].trim();
      if (!auswahl) continue;
      try {
        var element = document.querySelector(auswahl);
        if (element) return element;
      } catch (fehler) { /* ungueltiger Selektor wird uebersprungen */ }
    }
    return null;
  }

  function entprellen(arbeit, ms) {
    var uhr = null;
    return function () {
      var argumente = arguments;
      var selbst = this;
      clearTimeout(uhr);
      uhr = setTimeout(function () { arbeit.apply(selbst, argumente); }, ms);
    };
  }

  function hole(pfad, parameter) {
    var url = new URL(BASIS + pfad, window.location.origin);
    Object.keys(parameter || {}).forEach(function (schluessel) {
      var wert = parameter[schluessel];
      if (wert === undefined || wert === null || wert === '') return;
      url.searchParams.set(schluessel, wert);
    });
    return fetch(url.toString(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
        return antwort.json();
      });
  }

  // -------------------------------------------------------------------------
  // Zustand aus der Adresszeile
  // -------------------------------------------------------------------------
  function leseZustand() {
    var parameter = new URLSearchParams(window.location.search);
    var filter = {};
    parameter.forEach(function (wert, schluessel) {
      if (schluessel.indexOf('f.') !== 0) return;
      var feld = schluessel.slice(2);
      filter[feld] = (filter[feld] || []).concat(String(wert).split('|').filter(Boolean));
    });
    return {
      begriff: parameter.get('q') || '',
      sortierung: parameter.get('sortierung') || 'relevanz',
      preisMin: parameter.get('preis_min') || '',
      preisMax: parameter.get('preis_max') || '',
      seite: Number(parameter.get('seite') || 1),
      filter: filter
    };
  }

  function schreibeZustand(zustand, ersetzen) {
    var parameter = new URLSearchParams(window.location.search);
    Array.from(parameter.keys()).forEach(function (schluessel) {
      if (schluessel.indexOf('f.') === 0) parameter.delete(schluessel);
    });
    ['sortierung', 'preis_min', 'preis_max', 'seite'].forEach(function (s) { parameter.delete(s); });

    if (zustand.begriff) parameter.set('q', zustand.begriff);
    if (zustand.sortierung && zustand.sortierung !== 'relevanz') parameter.set('sortierung', zustand.sortierung);
    if (zustand.preisMin) parameter.set('preis_min', zustand.preisMin);
    if (zustand.preisMax) parameter.set('preis_max', zustand.preisMax);
    Object.keys(zustand.filter).forEach(function (feld) {
      if (zustand.filter[feld].length) parameter.set('f.' + feld, zustand.filter[feld].join('|'));
    });
    var neu = window.location.pathname + (parameter.toString() ? '?' + parameter.toString() : '');
    if (ersetzen) window.history.replaceState({ oc: true }, '', neu);
    else window.history.pushState({ oc: true }, '', neu);
  }

  function anfrageParameter(zustand) {
    var parameter = {
      q: zustand.begriff,
      sortierung: zustand.sortierung,
      preis_min: zustand.preisMin,
      preis_max: zustand.preisMax,
      seite: zustand.seite
    };
    Object.keys(zustand.filter).forEach(function (feld) {
      if (zustand.filter[feld].length) parameter['f.' + feld] = zustand.filter[feld].join('|');
    });
    /* Kategorieseiten: Der Ausschnitt der Seite geht als normaler
       Facettenfilter mit, f.kategorie oder f.unterkategorie. Welches der
       beiden Felder gilt, entscheidet das Snippet anhand des Metafelds
       custom.collection_type und legt es in konfig.kategorieFilter ab.

       Frueher stand hier ein pauschales parameter.kollektion. Der Dienst
       hat das immer als Unterkategorie gelesen (proxy.js, leseFilter),
       deshalb kamen auf Hauptkategorieseiten null Treffer.

       Hat der Besucher selbst einen Filter auf demselben Feld gesetzt,
       hat seine Wahl Vorrang. Deshalb nur setzen, wenn noch nichts
       dasteht. */
    if (konfig.kategorieFilter && konfig.kategorieFilter.feld && konfig.kategorieFilter.wert) {
      var katSchluessel = 'f.' + konfig.kategorieFilter.feld;
      if (!parameter[katSchluessel]) parameter[katSchluessel] = konfig.kategorieFilter.wert;
    }
    return parameter;
  }

  // -------------------------------------------------------------------------
  // Ergebnisdarstellung
  // -------------------------------------------------------------------------
  /* Baut eine Ergebniskachel.

     Aufbau und Reihenfolge folgen der Shop-Produktkarte aus
     snippets/oc-product-card.liquid: Bild, Haendler, Titel, UVP, Preis,
     Grundpreis, Hinweis zum Bestand. Wer die beiden nebeneinander sieht,
     soll keinen Unterschied bemerken.

     Kein Warenkorb-Knopf: Die Kachel fuehrt auf die Produktseite, dort
     kauft der Kunde wie gewohnt. Dem Treffer fehlt dafuer ohnehin die
     Varianten-Kennung.

     Genutzt werden nur Felder, die der Dienst wirklich liefert:
     bild, bildAlt, titel, haendler, preis, waehrung, vergleichspreis,
     imAngebot, grundpreisText, verfuegbar, url, gid. */
  function kachel(treffer, position, begriff) {
    var bild = treffer.bild
      ? '<img class="oc-kachel__bild" src="' + sicher(treffer.bild) + '&width=400" alt="' + sicher(treffer.bildAlt) + '" loading="lazy" width="400" height="400">'
      : '<span class="oc-kachel__bild oc-kachel__bild--leer" aria-hidden="true"></span>';

    var abzeichen = treffer.imAngebot
      ? '<span class="oc-abzeichen">' + sicher(TEXTE.angebot) + '</span>' : '';

    var haendler = treffer.haendler
      ? '<span class="oc-kachel__haendler">' + sicher(TEXTE.verkauft_von) + ' '
        + '<span class="oc-kachel__haendler-name">' + sicher(treffer.haendler) + '</span></span>'
      : '';

    /* UVP steht als eigene Zeile ueber dem Preis. Das Label bleibt
       ungestrichen, nur der Betrag wird durchgestrichen. */
    var uvp = (treffer.imAngebot && treffer.vergleichspreis)
      ? '<span class="oc-kachel__uvp">'
        + '<span class="oc-kachel__uvp-label">' + sicher(TEXTE.uvp_label) + '</span>'
        + '<s class="oc-kachel__streich">' + sicher(preisText(treffer.vergleichspreis, treffer.waehrung)) + '</s>'
        + '</span>'
      : '';

    var preis = '<span class="oc-kachel__preis-zeile">'
      + '<span class="oc-kachel__preis">' + sicher(preisText(treffer.preis, treffer.waehrung)) + '</span>'
      + '</span>';

    var grund = treffer.grundpreisText
      ? '<span class="oc-kachel__grundpreis">' + sicher(treffer.grundpreisText) + '</span>' : '';

    /* Nur die ausdrueckliche Fehlanzeige wird gezeigt. "Auf Lager" an jeder
       Kachel waere Rauschen, und ein fehlendes Feld (aeltere Antwort des
       Dienstes) darf nicht als "nicht vorraetig" gelesen werden, deshalb
       der Vergleich auf genau false. */
    var bestand = (treffer.verfuegbar === false)
      ? '<span class="oc-kachel__bestand">' + sicher(TEXTE.nicht_vorraetig) + '</span>' : '';

    return '<li class="oc-kachel">'
      + '<a class="oc-kachel__link" href="' + sicher(treffer.url) + '"'
      + ' data-oc-klick="' + sicher(treffer.gid) + '" data-oc-position="' + position + '"'
      + ' data-oc-begriff="' + sicher(begriff) + '">'
      + '<span class="oc-kachel__medien">' + abzeichen + bild + '</span>'
      + '<span class="oc-kachel__body">'
      + haendler
      + '<span class="oc-kachel__titel">' + sicher(treffer.titel) + '</span>'
      + uvp
      + preis
      + grund
      + bestand
      + '</span></a></li>';
  }

  function facettenBlock(facette) {
    if (facette.typ === 'bereich') {
      return '<fieldset class="oc-facette" data-feld="' + sicher(facette.schluessel) + '">'
        + '<legend class="oc-facette__titel">' + sicher(facette.label) + '</legend>'
        + '<div class="oc-bereich">'
        + '<label><span class="oc-visuell-versteckt">' + sicher(TEXTE.preis_von) + '</span>'
        + '<input type="number" inputmode="decimal" class="oc-bereich__feld" data-oc-preis="min" '
        + 'min="' + facette.min + '" max="' + facette.max + '" step="0.01" placeholder="' + sicher(TEXTE.preis_von) + '" '
        + 'value="' + (facette.gewaehlt && facette.gewaehlt.min ? sicher(facette.gewaehlt.min) : '') + '"></label>'
        + '<span aria-hidden="true">\u2013</span>'
        + '<label><span class="oc-visuell-versteckt">' + sicher(TEXTE.preis_bis) + '</span>'
        + '<input type="number" inputmode="decimal" class="oc-bereich__feld" data-oc-preis="max" '
        + 'min="' + facette.min + '" max="' + facette.max + '" step="0.01" placeholder="' + sicher(TEXTE.preis_bis) + '" '
        + 'value="' + (facette.gewaehlt && facette.gewaehlt.max ? sicher(facette.gewaehlt.max) : '') + '"></label>'
        + '</div></fieldset>';
    }

    var werte = (facette.werte || []).map(function (wert) {
      var kennung = 'ocf-' + facette.schluessel.replace(/[^a-z0-9]+/gi, '-') + '-'
        + wert.wert.replace(/[^a-z0-9]+/gi, '-').slice(0, 40);
      return '<li class="oc-facette__wert">'
        + '<input type="checkbox" id="' + sicher(kennung) + '" data-oc-filter="' + sicher(facette.schluessel) + '"'
        + ' value="' + sicher(wert.wert) + '"' + (wert.gewaehlt ? ' checked' : '') + '>'
        + '<label for="' + sicher(kennung) + '">' + sicher(wert.wert)
        + ' <span class="oc-facette__zahl">' + wert.anzahl + '</span></label></li>';
    }).join('');

    return '<fieldset class="oc-facette' + (facette.eingeklappt ? ' oc-facette--zu' : '') + '"'
      + ' data-feld="' + sicher(facette.schluessel) + '">'
      + '<legend class="oc-facette__titel">'
      + '<button type="button" class="oc-facette__schalter" aria-expanded="' + (facette.eingeklappt ? 'false' : 'true') + '">'
      + sicher(facette.label) + '</button></legend>'
      + '<ul class="oc-facette__liste">' + werte + '</ul></fieldset>';
  }

  function baueOberflaeche(daten, zustand) {
    var kopf = '<div class="oc-kopf">'
      + '<h2 class="oc-kopf__titel">' + sicher(zustand.begriff
        ? TEXTE.ergebnisse_fuer + ' \u201e' + zustand.begriff + '\u201c'
        : TEXTE.ergebnisse_titel) + '</h2>'
      + '<p class="oc-kopf__zahl" role="status">' + daten.gesamt.toLocaleString('de-DE')
      + ' ' + sicher(TEXTE.treffer_mehrzahl) + '</p>'
      + (daten.korrektur
        ? '<p class="oc-korrektur">' + sicher(TEXTE.meintest_du) + ' '
          + '<button type="button" class="oc-korrektur__knopf">' + sicher(daten.korrektur) + '</button></p>'
        : '')
      + '</div>';

    /* Knopf, der auf schmalen Schirmen die Filterspalte als Overlay
       aufzieht. Er steht in derselben Leiste wie die Sortierung und ist auf
       dem Desktop per CSS ausgeblendet, dort steht die Spalte ja links.

       Die Zahl in Klammern ist die Menge der gesetzten Filter, damit man
       im zugeklappten Zustand sieht, dass ueberhaupt gefiltert wird.

       aria-expanded wird aus der Klasse am body gelesen, nicht fest auf
       false gesetzt: baueOberflaeche laeuft bei jeder Filteraenderung neu,
       und dabei kann das Overlay offen sein. */
    var aktiveFilter = 0;
    Object.keys(zustand.filter).forEach(function (feld) {
      aktiveFilter += (zustand.filter[feld] || []).length;
    });
    if (zustand.preisMin || zustand.preisMax) aktiveFilter += 1;
    var offen = document.body.classList.contains('oc-filter-offen');
    var filterKnopf = '<button type="button" class="oc-filterknopf" data-oc-filter-auf'
      + ' aria-expanded="' + (offen ? 'true' : 'false') + '">'
      + sicher(TEXTE.filter_titel)
      + (aktiveFilter ? ' (' + aktiveFilter + ')' : '')
      + '</button>';

    var sortierung = '<label class="oc-sortierung">'
      + '<span>' + sicher(TEXTE.sortierung_label) + '</span>'
      + '<select data-oc-sortierung>'
      + [['relevanz', TEXTE.sortierung_relevanz], ['preis_auf', TEXTE.sortierung_preis_auf],
         ['preis_ab', TEXTE.sortierung_preis_ab], ['neu', TEXTE.sortierung_neu],
         ['bestseller', TEXTE.sortierung_bestseller]]
        .map(function (paar) {
          return '<option value="' + paar[0] + '"' + (zustand.sortierung === paar[0] ? ' selected' : '') + '>'
            + sicher(paar[1]) + '</option>';
        }).join('')
      + '</select></label>';

    var sichtbare = (daten.facetten || []).filter(function (f) { return !f.eingeklappt; });
    var weitere = (daten.facetten || []).filter(function (f) { return f.eingeklappt; });
    /* Dieselbe Spalte dient auf dem Desktop als Seitenspalte und auf dem
       Telefon als Overlay. Es gibt bewusst nur EINE Filterliste, damit die
       vorhandenen Handler an data-oc-filter unveraendert greifen.
       Dazugekommen sind nur ein Schliesskreuz oben und ein fester Balken
       unten, beide ausschliesslich fuer das Overlay, auf dem Desktop per
       CSS ausgeblendet. */
    var filterspalte = '<aside class="oc-filter" aria-label="' + sicher(TEXTE.filter_titel) + '">'
      + '<div class="oc-filter__kopf"><h3>' + sicher(TEXTE.filter_titel) + '</h3>'
      + '<button type="button" class="oc-textknopf" data-oc-zuruecksetzen>' + sicher(TEXTE.filter_zuruecksetzen) + '</button>'
      + '<button type="button" class="oc-filter__schliessen" data-oc-filter-zu'
      + ' aria-label="' + sicher(TEXTE.filter_schliessen) + '">&times;</button></div>'
      + sichtbare.map(facettenBlock).join('')
      + (weitere.length
        ? '<details class="oc-weitere"><summary>' + sicher(TEXTE.filter_weitere) + '</summary>'
          + weitere.map(facettenBlock).join('') + '</details>'
        : '')
      + '<div class="oc-filter__fuss">'
      + '<button type="button" class="oc-knopf" data-oc-filter-zu>'
      + sicher(TEXTE.filter_anzeigen) + ' (' + daten.gesamt.toLocaleString('de-DE') + ')'
      + '</button></div>'
      + '</aside>';

    var liste;
    if (daten.gesamt === 0) {
      var alternativen = '';
      (daten.alternativen || []).forEach(function (block) {
        if (block.art === 'kategorien' && block.eintraege.length) {
          alternativen += '<p class="oc-leer__zeile">' + block.eintraege.map(function (e) {
            return '<button type="button" class="oc-chip" data-oc-filter-schnell="kategorie" data-wert="'
              + sicher(e.wert) + '">' + sicher(e.wert) + '</button>';
          }).join(' ') + '</p>';
        }
        if (block.art === 'bestseller' && block.eintraege.length) {
          alternativen += '<h3 class="oc-leer__titel">' + sicher(TEXTE.beliebt_titel) + '</h3>'
            + '<ul class="oc-gitter">' + block.eintraege.map(function (t, i) {
              return kachel(t, i + 1, zustand.begriff);
            }).join('') + '</ul>';
        }
      });
      liste = '<div class="oc-leer"><h3>' + sicher(TEXTE.keine_treffer_titel) + '</h3>'
        + '<p>' + sicher(TEXTE.keine_treffer_text) + '</p>' + alternativen + '</div>';
    } else {
      liste = '<ul class="oc-gitter" data-oc-gitter>'
        + daten.treffer.map(function (t, i) {
          return kachel(t, (zustand.seite - 1) * daten.proSeite + i + 1, zustand.begriff);
        }).join('')
        + '</ul>';
      if (daten.seite < daten.seiten) {
        liste += '<div class="oc-mehr"><button type="button" class="oc-knopf" data-oc-mehr>'
          + sicher(TEXTE.mehr_laden) + '</button></div>';
      }
    }

    return '<section class="oc-suche" data-oc-wurzel>'
      + kopf
      + '<div class="oc-leiste">' + filterKnopf + sortierung + '</div>'
      + '<div class="oc-spalten">' + filterspalte
      + '<div class="oc-ergebnisse">' + liste + '</div></div>'
      + '</section>';
  }

  // -------------------------------------------------------------------------
  // Ergebnisseite steuern
  // -------------------------------------------------------------------------
  function starteErgebnisseite(behaelter, nativeAusgabe) {
    var zustand = leseZustand();
    var laeuft = false;

    function zeichne(daten) {
      Object.assign(TEXTE, daten.texte || {});
      if (daten.weiterleitung) { window.location.href = daten.weiterleitung; return; }
      behaelter.innerHTML = baueOberflaeche(daten, zustand);
      behaelter.hidden = false;
      if (nativeAusgabe && nativeAusgabe !== behaelter) nativeAusgabe.hidden = true;
      behaelter.dataset.gesamt = String(daten.gesamt);
      behaelter.dataset.seiten = String(daten.seiten);

      /* Tab-Titel richtigstellen. Im Titel steht sonst weiter, was Shopify
         beim Ausliefern der Seite hineingeschrieben hat, also die Zahl der
         NATIVEN Treffer. Die ist bei unserem Katalog fast immer 0 und
         widerspricht dem, was der Kunde vor sich sieht.

         Nur mit Suchbegriff: ohne Begriff ist der Titel der Seite richtig,
         wie er ist. */
      if (zustand.begriff) {
        document.title = 'Suche: ' + daten.gesamt.toLocaleString('de-DE') + ' '
          + (daten.gesamt === 1 ? 'Ergebnis' : 'Ergebnisse')
          + ' f\u00fcr ' + zustand.begriff;
      }
    }

    function laden(anhaengen) {
      if (laeuft) return;
      laeuft = true;
      behaelter.setAttribute('aria-busy', 'true');
      hole('/suche', anfrageParameter(zustand))
        .then(function (daten) {
          if (anhaengen) {
            Object.assign(TEXTE, daten.texte || {});
            var gitter = behaelter.querySelector('[data-oc-gitter]');
            if (gitter) {
              var start = (zustand.seite - 1) * daten.proSeite;
              gitter.insertAdjacentHTML('beforeend', daten.treffer.map(function (t, i) {
                return kachel(t, start + i + 1, zustand.begriff);
              }).join(''));
            }
            var knopf = behaelter.querySelector('[data-oc-mehr]');
            if (knopf && zustand.seite >= daten.seiten) knopf.parentNode.removeChild(knopf);
            if (knopf) knopf.disabled = false;
          } else {
            zeichne(daten);
          }
        })
        .catch(function (fehler) {
          // Fallback: native Ausgabe stehen lassen, eigene Schicht ausblenden.
          if (window.console && console.warn) console.warn('OneCircle Suche nicht erreichbar', fehler);
          behaelter.hidden = true;
          if (nativeAusgabe && nativeAusgabe !== behaelter) nativeAusgabe.hidden = false;
        })
        .then(function () {
          laeuft = false;
          behaelter.removeAttribute('aria-busy');
        });
    }

    function neuLaden() {
      zustand.seite = 1;
      schreibeZustand(zustand, false);
      laden(false);
    }

    behaelter.addEventListener('change', function (ereignis) {
      var ziel = ereignis.target;
      if (ziel.matches('[data-oc-filter]')) {
        var feld = ziel.dataset.ocFilter;
        var werte = zustand.filter[feld] || [];
        if (ziel.checked) { if (werte.indexOf(ziel.value) < 0) werte.push(ziel.value); }
        else { werte = werte.filter(function (w) { return w !== ziel.value; }); }
        zustand.filter[feld] = werte;
        neuLaden();
      } else if (ziel.matches('[data-oc-sortierung]')) {
        zustand.sortierung = ziel.value;
        neuLaden();
      } else if (ziel.matches('[data-oc-preis]')) {
        if (ziel.dataset.ocPreis === 'min') zustand.preisMin = ziel.value;
        else zustand.preisMax = ziel.value;
        neuLaden();
      }
    });

    behaelter.addEventListener('click', function (ereignis) {
      var ziel = ereignis.target.closest ? ereignis.target.closest('button, a') : null;
      if (!ziel) return;

      /* Overlay auf und zu. Der Zustand haengt am body, NICHT am gerade
         gebauten HTML: zeichne() ersetzt bei jeder Filteraenderung den
         kompletten Innenbereich, eine Klasse dort drin waere sofort wieder
         weg und das Overlay klappte bei jedem Haken zu. Am body ueberlebt
         sie jedes Neuzeichnen, ohne Flackern.

         An der Filter- und Sortierlogik aendert das nichts, hier wird nur
         umgeschaltet, was sichtbar ist. */
      if (ziel.matches('[data-oc-filter-auf]')) {
        document.body.classList.add('oc-filter-offen');
        ziel.setAttribute('aria-expanded', 'true');
        return;
      }
      if (ziel.matches('[data-oc-filter-zu]')) {
        document.body.classList.remove('oc-filter-offen');
        var auf = behaelter.querySelector('[data-oc-filter-auf]');
        if (auf) auf.setAttribute('aria-expanded', 'false');
        return;
      }

      if (ziel.matches('[data-oc-mehr]')) {
        ziel.disabled = true;
        zustand.seite += 1;
        laden(true);
        return;
      }
      if (ziel.matches('[data-oc-zuruecksetzen]')) {
        zustand.filter = {};
        zustand.preisMin = '';
        zustand.preisMax = '';
        neuLaden();
        return;
      }
      if (ziel.matches('[data-oc-filter-schnell]')) {
        zustand.filter[ziel.dataset.ocFilterSchnell] = [ziel.dataset.wert];
        zustand.begriff = '';
        neuLaden();
        return;
      }
      if (ziel.matches('.oc-korrektur__knopf')) {
        zustand.begriff = ziel.textContent.trim();
        neuLaden();
        return;
      }
      if (ziel.matches('.oc-facette__schalter')) {
        var feldsatz = ziel.closest('.oc-facette');
        var zu = feldsatz.classList.toggle('oc-facette--zu');
        ziel.setAttribute('aria-expanded', zu ? 'false' : 'true');
        return;
      }
      if (ziel.matches('[data-oc-klick]')) {
        meldeKlick(ziel.dataset.ocBegriff, ziel.dataset.ocKlick, Number(ziel.dataset.ocPosition || 0));
      }
    });

    window.addEventListener('popstate', function () {
      zustand = leseZustand();
      laden(false);
    });

    laden(false);
  }

  function meldeKlick(begriff, gid, position) {
    try {
      var koerper = JSON.stringify({ art: 'klick', begriff: begriff, gid: gid, position: position });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(BASIS + '/analytics', new Blob([koerper], { type: 'application/json' }));
      } else {
        fetch(BASIS + '/analytics', { method: 'POST', body: koerper, headers: { 'Content-Type': 'application/json' }, keepalive: true });
      }
    } catch (fehler) { /* Statistik darf nie stoeren */ }
  }

  // -------------------------------------------------------------------------
  // Autocomplete am bestehenden Suchfeld
  // -------------------------------------------------------------------------
  function ruesteSuchfelderAus() {
    var felder = document.querySelectorAll(konfig.suchfeldSelektor || 'input[name="q"]');
    Array.prototype.forEach.call(felder, function (feld) {
      if (feld.dataset.ocBereit === '1') return;
      feld.dataset.ocBereit = '1';
      ruesteEinSuchfeldAus(feld);
    });
  }

  function ruesteEinSuchfeldAus(feld) {
    var kennung = 'oc-vorschlag-' + Math.random().toString(36).slice(2, 8);
    var kasten = elementAus('<div class="oc-vorschlag" id="' + kennung + '" role="listbox" hidden></div>');
    var huelle = feld.closest('form') || feld.parentElement;
    if (!huelle) return;
    if (getComputedStyle(huelle).position === 'static') huelle.style.position = 'relative';
    huelle.appendChild(kasten);

    feld.setAttribute('role', 'combobox');
    feld.setAttribute('aria-autocomplete', 'list');
    feld.setAttribute('aria-expanded', 'false');
    feld.setAttribute('aria-controls', kennung);
    feld.setAttribute('autocomplete', 'off');

    var eintraege = [];
    var markiert = -1;

    function schliessen() {
      kasten.hidden = true;
      feld.setAttribute('aria-expanded', 'false');
      feld.removeAttribute('aria-activedescendant');
      markiert = -1;
    }

    function zeichnen(daten) {
      Object.assign(TEXTE, daten.texte || {});
      eintraege = [];
      var html = '';

      if (daten.korrektur) {
        html += '<p class="oc-vorschlag__hinweis">' + sicher(TEXTE.meintest_du) + ' <strong>'
          + sicher(daten.korrektur) + '</strong></p>';
      }
      if (daten.kategorien && daten.kategorien.length) {
        html += '<p class="oc-vorschlag__titel">' + sicher(TEXTE.vorschlag_kategorien) + '</p><ul class="oc-vorschlag__liste">';
        daten.kategorien.forEach(function (k) {
          var i = eintraege.length;
          eintraege.push({ art: 'kategorie', wert: k.wert });
          html += '<li id="' + kennung + '-' + i + '" role="option" class="oc-vorschlag__zeile" data-index="' + i + '">'
            + sicher(k.wert) + ' <span class="oc-vorschlag__zahl">' + k.anzahl + '</span></li>';
        });
        html += '</ul>';
      }
      if (daten.haendler && daten.haendler.length) {
        html += '<p class="oc-vorschlag__titel">' + sicher(TEXTE.vorschlag_haendler) + '</p><ul class="oc-vorschlag__liste">';
        daten.haendler.forEach(function (h) {
          var i = eintraege.length;
          eintraege.push({ art: 'haendler', wert: h.wert });
          html += '<li id="' + kennung + '-' + i + '" role="option" class="oc-vorschlag__zeile" data-index="' + i + '">'
            + sicher(h.wert) + ' <span class="oc-vorschlag__zahl">' + h.anzahl + '</span></li>';
        });
        html += '</ul>';
      }
      if (daten.produkte && daten.produkte.length) {
        html += '<p class="oc-vorschlag__titel">' + sicher(TEXTE.vorschlag_produkte) + '</p><ul class="oc-vorschlag__liste">';
        daten.produkte.forEach(function (p) {
          var i = eintraege.length;
          eintraege.push({ art: 'produkt', wert: p.url, gid: p.gid });
          html += '<li id="' + kennung + '-' + i + '" role="option" class="oc-vorschlag__zeile oc-vorschlag__produkt" data-index="' + i + '">'
            + (p.bild ? '<img src="' + sicher(p.bild) + '&width=80" alt="" width="40" height="40" loading="lazy">' : '')
            + '<span class="oc-vorschlag__text"><span class="oc-vorschlag__name">' + sicher(p.titel) + '</span>'
            + '<span class="oc-vorschlag__preis">' + sicher(preisText(p.preis, p.waehrung)) + '</span></span></li>';
        });
        html += '</ul>';
      }
      if (daten.gesamt > 0) {
        var letzter = eintraege.length;
        eintraege.push({ art: 'alle' });
        html += '<button type="button" id="' + kennung + '-' + letzter + '" role="option" '
          + 'class="oc-vorschlag__alle" data-index="' + letzter + '">'
          + sicher(TEXTE.alle_ergebnisse) + ' (' + daten.gesamt.toLocaleString('de-DE') + ')</button>';
      }

      if (!html) { schliessen(); return; }
      kasten.innerHTML = html;
      kasten.hidden = false;
      feld.setAttribute('aria-expanded', 'true');
      markiert = -1;
    }

    function waehlen(index) {
      var eintrag = eintraege[index];
      if (!eintrag) return;
      var suchpfad = konfig.suchpfad || '/search';
      if (eintrag.art === 'produkt') window.location.href = eintrag.wert;
      else if (eintrag.art === 'kategorie') window.location.href = suchpfad + '?f.kategorie=' + encodeURIComponent(eintrag.wert);
      else if (eintrag.art === 'haendler') window.location.href = suchpfad + '?f.haendler=' + encodeURIComponent(eintrag.wert);
      else window.location.href = suchpfad + '?q=' + encodeURIComponent(feld.value);
    }

    function markiere(neu) {
      var zeilen = kasten.querySelectorAll('[role="option"]');
      if (!zeilen.length) return;
      if (markiert >= 0 && zeilen[markiert]) zeilen[markiert].classList.remove('oc-markiert');
      markiert = (neu + zeilen.length) % zeilen.length;
      zeilen[markiert].classList.add('oc-markiert');
      feld.setAttribute('aria-activedescendant', zeilen[markiert].id);
      if (zeilen[markiert].scrollIntoView) zeilen[markiert].scrollIntoView({ block: 'nearest' });
    }

    var suchen = entprellen(function () {
      var wert = feld.value.trim();
      if (wert.length < (konfig.minZeichen || 2)) { schliessen(); return; }
      hole('/vorschlag', { q: wert }).then(zeichnen).catch(schliessen);
    }, konfig.entprellenMs || 180);

    feld.addEventListener('input', suchen);
    feld.addEventListener('focus', function () { if (feld.value.trim().length >= (konfig.minZeichen || 2)) suchen(); });
    feld.addEventListener('keydown', function (ereignis) {
      if (kasten.hidden) return;
      if (ereignis.key === 'ArrowDown') { ereignis.preventDefault(); markiere(markiert + 1); }
      else if (ereignis.key === 'ArrowUp') { ereignis.preventDefault(); markiere(markiert - 1); }
      else if (ereignis.key === 'Enter' && markiert >= 0) { ereignis.preventDefault(); waehlen(markiert); }
      else if (ereignis.key === 'Escape') { schliessen(); }
    });
    kasten.addEventListener('mousedown', function (ereignis) {
      var zeile = ereignis.target.closest('[data-index]');
      if (!zeile) return;
      ereignis.preventDefault();
      waehlen(Number(zeile.dataset.index));
    });
    document.addEventListener('click', function (ereignis) {
      if (!kasten.contains(ereignis.target) && ereignis.target !== feld) schliessen();
    });
  }

  // -------------------------------------------------------------------------
  // Empfehlungsflaeche
  // -------------------------------------------------------------------------
  function ladeEmpfehlungen() {
    var flaechen = document.querySelectorAll('[data-oc-empfehlungen]');
    Array.prototype.forEach.call(flaechen, function (flaeche) {
      var gid = flaeche.dataset.ocProdukt || '';
      hole('/empfehlungen', { gid: gid })
        .then(function (daten) {
          Object.assign(TEXTE, daten.texte || {});
          var art = flaeche.dataset.ocEmpfehlungen || 'verwandt';
          var liste = daten[art] && daten[art].length ? daten[art] : daten.beliebt;
          if (!liste || !liste.length) return;
          flaeche.innerHTML = '<h2 class="oc-kopf__titel">'
            + sicher(art === 'beliebt' ? TEXTE.beliebt_titel : TEXTE.empfehlungen_titel) + '</h2>'
            + '<ul class="oc-gitter oc-gitter--schmal">'
            + liste.map(function (t, i) { return kachel(t, i + 1, ''); }).join('') + '</ul>';
          flaeche.hidden = false;
        })
        .catch(function () { flaeche.hidden = true; });
    });
  }

  // -------------------------------------------------------------------------
  // Start
  // -------------------------------------------------------------------------
  function start() {
    ruesteSuchfelderAus();
    ladeEmpfehlungen();

    if (!konfig.ergebnisseAktiv) return;

    var eigenerBehaelter = document.querySelector('[data-oc-ergebnisblock]');
    var nativeAusgabe = ersterTreffer((konfig.ergebnisSelektoren || '').split(','));

    var behaelter = eigenerBehaelter;
    if (!behaelter && nativeAusgabe) {
      behaelter = document.createElement('div');
      behaelter.setAttribute('data-oc-ergebnisblock', '');
      behaelter.hidden = true;
      nativeAusgabe.parentNode.insertBefore(behaelter, nativeAusgabe);
    }
    if (!behaelter) return;

    starteErgebnisseite(behaelter, nativeAusgabe);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme-Editor: nach dem Neuladen eines Abschnitts erneut andocken
  document.addEventListener('shopify:section:load', function () { ruesteSuchfelderAus(); });
}());
